/**
 * Created by rak on 8/26/2016.
 */
'use strict';

angular.module('dashboard.deviceSummary', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('TempMonitoringWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.tempMonitoringWidget.title';
          },
          description: function () {
            return 'dashBoard.fleetManagement.tempMonitoringWidget.description';
          }
        },
        controller: 'TempMonitoringCtrl',
        templateUrl: 'components/dashboard/deviceSummary/deviceSummaryWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          height: 450,
          maxHours: 2,
          temperatureUnit: '',
          max: null,
          min: null
        },
        edit: {
          templateUrl: 'components/dashboard/deviceSummary/deviceSummaryWidgetEdit.tpl.html',
          reload: true,
          controller: 'TempMonitoringEditCtrl',
          apply: function (config, TempMonitoringService) {
            TempMonitoringService.saveTemperatureConfiguration(config);
          }
        }
      });
  }).service('TempMonitoringService', function (crudService, localStorageService, AuthenticationService) {

    var _hasRowEventRecieved = false;
    this.getThermoEventDatalList = function (deviceId, startDate, endDate, loadConsistencyData) {
      var requestParam = {
        timeTo: endDate,
        timeFrom: startDate,
        reportName: loadConsistencyData ? 'EventSummaryConsistencyCharts' : 'EventSummaryCharts',
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };

      if (loadConsistencyData) {
        return crudService.customGET('overview', 'devicesummaryconsistencycharts/' + deviceId, param);
      }
      return crudService.customGET('overview', 'devicesummarycharts/' + deviceId, param);
    };

	this.getFuelHistory = function (deviceId, startDate, endDate) {
	  if (!deviceId || !endDate) {
		  console.log('Cannot get fuel history without device ID and end date');
		  return;
	  }

      var requestParam = {
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'DailyDistanceDetail',
		deviceid: deviceId,
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('vehicledetailsreport', 'dailydistancedetail', param);
    };

    this.getSummaryDetails = function (deviceId) {
      var requestParam = {
        reportName: 'EventThermo'
      };

      var param = {
        'filter': JSON.stringify(requestParam)
      };

      return crudService.customGET('vehicledetailsreport', 'devicesummary/' + deviceId, param);
    };


    this.saveChartState = function (chartSeries) {
      var loginID = AuthenticationService.GetLoginID();
      localStorageService.set('fleetSettings.tempChartSeries.' + loginID.Account + '.' + loginID.username, chartSeries);
    };

    this.getChartState = function () {
      var loginID = AuthenticationService.GetLoginID();
      var chartSeries = localStorageService.get('fleetSettings.tempChartSeries.' + loginID.Account + '.' + loginID.username);
      if (chartSeries !== null) {
        return chartSeries;
      }
      return chartSeries;
    };

    this.saveTempRangeValues = function (range, unit) {
      var loginID = AuthenticationService.GetLoginID();
      var tmpRange = this.getTemperatureRangeValue() || {};
      if (unit === 1) {
        tmpRange.c = {
          to: range.to,
          from: range.from
        };
      } else {
        tmpRange.f = {
          to: range.to,
          from: range.from
        };
      }
      localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange', tmpRange);
    };
    this.getTemperatureRangeValue = function () {
      var loginID = AuthenticationService.GetLoginID();
      var rangeValue = localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange');
      if (rangeValue !== null) {
        return rangeValue;
      }
      return null;
    };

    this.saveTemperatureConfiguration = function (configObj) {
      var loginID = AuthenticationService.GetLoginID();
      localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.configuration', configObj);
    };

    this.getTemperatureConfiguration = function () {
      var loginID = AuthenticationService.GetLoginID();
      return localStorageService.get('fleetSettings.' + loginID.Account + '.' + loginID.username + '.configuration');
    };

    this.saveIntialTmparatueRangeValues = function (unit) {
      var loginID = AuthenticationService.GetLoginID();
      var range = {
        c: {},
        f: {}
      };

      if (unit === 1) {
        range.c = {
          to: 10,
          from: -12
        };
      }
      else {
        range.f = {
          to: 50,
          from: 10
        };
      }
      localStorageService.set('fleetSettings.' + loginID.Account + '.' + loginID.username + '.tempRange', range);
    };

    this.setRowEventStatus = function (status) {
      _hasRowEventRecieved = status;
    };
    this.getRowEventStatus = function () {
      return _hasRowEventRecieved;
    };
    this.isFullScreen = function () {

    };

  }).controller('TempMonitoringCtrl', function ($scope, $q, TempMonitoringService, stateManagerService, config, commonTrackService, $translate, $timeout, $state, errorHandlingService, $rootScope, AuthenticationService, $interval) {
    $scope.temperatureDetail = {
      date: {
        startDate: new Date().setHours(0, 0, 0, 0),
        endDate: new Date()
      }
    };

    $scope.doorStatusChartSettings = {};
    $scope.tempratursChartHistory = {};

    $scope.parentWidgetData = {};
    $scope.summaryData = { isStartTime: true };

    var getSpeedUnitString = function () {
      switch ($scope.accountSettings.speedUnits) {
        case 0:
          return 'mph';
        case 1:
          return 'km/h';
        case 2:
          return 'knots';
        default:
          return $scope.accountSettings.speedUnits;
      }
    };

    var getEconomyUnitString = function (economyUnit) {

      switch (economyUnit) {
        case 0:
          return 'mpg';
        case 1:
          return 'km/L';
        case 2:
          return 'kpg';
        case 3:
          return 'L/100km';
        default:
          return economyUnit;
      }
    };

    var loadGtsAccountSettings = function () {
      commonTrackService.getGtsAccountSettings(true).then(function (data) {
        $scope.accountSettings = data;


        var fueleconomyUnit = getEconomyUnitString($scope.accountSettings.economyUnits);
        var speedUnit = getSpeedUnitString();



        $scope.fuelChartSettings = {
          title: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.chartHeading'),
          description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
          padding: { left: 15, top: 5, right: 30, bottom: 5 },
          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: {
            dataField: 'time',

            displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.xAxisHeader'),
            valuesOnTicks: true,
          },
          colorScheme: 'scheme04',

          seriesGroups: [{
            type: 'spline',
            valueAxis:
            {
              visible: true,
              position: 'left',
              axisSize: 'auto',
              minValue: 0,
              title: { text: fueleconomyUnit },
            },
            series: [
              { dataField: 'fueleconomytotal', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel1') + ' - ' + fueleconomyUnit },
              { dataField: 'fueleconomyengineon', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel2') + ' - ' + fueleconomyUnit },

            ]
          }, {
            type: 'spline',
            valueAxis:
            {
              visible: true,
              position: 'left',
              axisSize: 'auto',
              maxValue: 100,
              gridLines: { visible: false },
              minValue: 0,
              title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel4') + ' %' },
            },
            series: [
              { dataField: 'fuellevel', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel4'), color: '#0366fc' }
            ]
          }, {
            type: 'spline',
            valueAxis:
            {
              visible: true,
              position: 'right',
              axisSize: 'auto',
              minValue: 0,
              gridLines: { visible: false },
              title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel3') + ' - ' + speedUnit },
            },
            series: [
              { dataField: 'speed', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel3') + ' - ' + speedUnit }
            ]
          }]
        };

		$scope.fuelChart2Settings = {
          title: $translate.instant('trackReporting.vehicleDetailReport.dailyDistanceDetail'),
          description: '',
          showLegend: true,
          enableAnimations: true,
          padding: { left: 5, top: 5, right: 5, bottom: 5 },
          titlePadding: { left: 90, top: 0, right: 0, bottom: 10 },
          source: [],
          xAxis:
          {
            dataField: 'date',
            formatFunction: function (value) {
              return moment(value).format('DD/MM/YYYY');
            },
            type: 'date',
            baseUnit: 'day',
            gridLines: { visible: true },
            valuesOnTicks: false
          },
          colorScheme: 'scheme01',
          columnSeriesOverlap: false,
          seriesGroups:
          [{
            type: 'column',
			columnsGapPercent : 50,
            valueAxis:
            {
			  visible: true,
              position: 'left',
              axisSize: 'auto',
              minValue : 0,
              title: { text: 'km'},
            },
            series: [
              { dataField: 'odomdelta', displayText: $translate.instant('trackReporting.vehicleDetailReport.dailyDistanceDetail')+ ' - km', color: 'lightblue'}
            ]
          },{
            type: 'column',
			columnsGapPercent : 50,
            valueAxis:
            {
			  visible: true,
              position: 'left',
              axisSize: 'auto',
              minValue : 0,
              title: { text: 'L'},
            },
            series: [
			  { dataField: 'fueltrip', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.trip' ) + ' - L', color: 'blue'}
            ]
          },{
            type: 'column',
			columnsGapPercent : 50,
            valueAxis:
            {
			  visible: true,
              position: 'right',
              axisSize: 'auto',
              minValue : 0,
              title: { text: 'L/100km'},
            },
            series: [
			  { dataField: 'fueleconomytotal', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.fuel.valueLabel1') + ' - L/100km', color: 'darkblue'},
            ]
          }]
         };

        $scope.$on('jqxChartCreated', function () {
          $('#jqxFuelChart').jqxChart('hideSerie', 1, 0);
        });

        $scope.weightChartSettings = {
          title: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.chartHeading'),
          description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
          padding: { left: 15, top: 5, right: 30, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: {
            dataField: 'time',
            displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.xAxisHeader'),
            valuesOnTicks: true,
          },
          colorScheme: 'scheme04',
          valueAxis:
          {
            visible: true,
            title: { text: 'kg' },
          },
          seriesGroups: [{
            type: 'spline',
            series: [
              { dataField: 'combinedweight', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.valueLabel1') },
              { dataField: 'axleweight', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.weight.valueLabel2') },
            ]
          }]
        };

        $scope.consistencyDataSource = [];

        var consistencyXAxisDescription = {
          dataField: 'timeindex',
          displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.xAxisHeader'),
          valuesOnTicks: true,
          formatFunction: function (value) {
            if (!$scope.consistencyDataSource || $scope.consistencyDataSource.length <= value) {
              return '';
            }
            return $scope.consistencyDataSource[value].time;
          },
        };

        $scope.consistencyChart1Settings = {
          title: '',
          description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
          padding: { left: 34, top: 5, right: 72, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: consistencyXAxisDescription,
          seriesGroups:[{
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'left',
                axisSize: 'auto',
                title: { text: 'bar' },
            },
            series: [
              { dataField: 'oilinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel5'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'green';} },
            ],
        },
        {
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'right',
                axisSize: 'auto',
                title: { text: 'Millivolt' },
            },
            series: [
              { dataField: 'oilinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel1'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'pink';} },
            ],
          }],

        };

        $scope.consistencyChartWaterSettings = {
          title: '',
          description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
          padding: { left: 34, top: 5, right: 72, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: consistencyXAxisDescription,
          seriesGroups:[{
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'left',
                axisSize: 'auto',
                title: { text: 'litres' },
            },
            series: [
              { dataField: 'waterinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel7'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'green';} },
            ],
          },
          {
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'right',
                axisSize: 'auto',
                title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.millivolt') },
            },
            series: [
              { dataField: 'waterinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel6'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'pink';} },
            ],
          }],

        };
		
		$scope.consistencyChartTemperatureSettings = {
          title: '',
          description: _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate,
          padding: { left: 34, top: 5, right: 72, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: consistencyXAxisDescription,
          seriesGroups:[{
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'left',
                axisSize: 'auto',
                title: { text: String('\xB0') +'C' },
            },
            series: [
              { dataField: 'hydraulicoiltemperatureinputconverted', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel8') + ' (' + String('\xB0') +'C' + ')', emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'green';} },
            ],
          },
          {
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'right',
                axisSize: 'auto',
                title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.millivolt') },
            },
            series: [
              { dataField: 'hydraulicoiltemperatureinputraw', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel8') + ' (mv)', emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'pink';} },
            ],
          }],

        };

        $scope.consistencyChart2Settings = {
          title: '',
          description: '',
          padding: { left: 15, top: 5, right: 30, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: consistencyXAxisDescription,
          seriesGroups:[{
            type: 'stepline',
            valueAxis:
            {
                visible: true,
                position: 'left',
                axisSize: 'auto',
                title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel2') },
            },
            series: [
              { dataField: 'cargorotation', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel2'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'green';} },
            ],
          },
		  {
            type: 'spline',
            valueAxis:
            {
                visible: true,
                position: 'right',
                axisSize: 'auto',
                title: { text: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel3') },
            },
            series: [
              { dataField: 'enginerpm', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel3'), emptyPointsDisplay: 'connect',
              colorFunction: function () { return 'pink';} },
            ],
          }]
        };

        $scope.consistencyChart3Settings = {
          title: '',
          description: '',
          padding: { left: 31, top: 5, right: 68, bottom: 5 },

          enableAnimations: true,
          showLegend: true,
          source: [],
          xAxis: consistencyXAxisDescription,
          valueAxis:
          {
              visible: true,
              title: { text:  String('\xB0') +'C'},
          },
          seriesGroups:[{
            type: 'spline',
            series: [
              { dataField: 'ambienttemp', displayText: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.valueLabel4'), emptyPointsDisplay: 'connect',
                colorFunction: function () { return 'red';} },
            ],
          }]
        };
      });
    };

    loadGtsAccountSettings();

    $scope.isNotSummaryChartsAuthorized = false;
    $scope.isDataNotAvailable = false;
    $scope.isWidgetPreInitFinished = false; // Pre ini animation automatically removed if anoy one of above two flags set to true
    $scope.isWidgetPostInitFinished = false;
    $scope.reloadChartData = true;
    $scope.reloadConsistencyChartData = true;
    $scope.thermoDataLoading = true;
	$scope.reloadFuelHistory = true;

    $scope.summaryCardData = {
      showMaintenanceContent: true,
      showCurrentJobContent: true,
      showVehicleStateContent: true,
      showVehicleInfoContent: true,
      isloading: true
    };

    $scope.rangeSelection = {
      from: 0,
      to: 0
    };

    var _serverTimeFormat = {};
    var _accountSettings = null;
    var _temperatureUnit = '';


    // model properties for new auto refresh checkbox in constancy tab
    // model proeprties for the new accordion for each chart under consitancy tab
    $scope.consitancytab = {
      hasAutoRefresh: 0,
      isAmbientTempChartOpen: true,
      ambientTempChartHeight:'300px',
      isConsistancyChartOpen: true,
      consistancyChartHeight:'300px',
      isDrumRpmChartOpen: true,
      drumRpmChartHeight:'300px',
      isConsistencyChartWaterOpen: true,
      consistencyChartWaterHeight:'300px',
      isConsistencyChartTemperatureOpen: true,
      consistencyChartTemperatureHeight:'300px',
      consitancyTabAutoRefreshLabel: $translate.instant('dashBoard.fleetManagement.temperatureDetail.consistency.consistencyAutoRefreshLabel'),

    };

    commonTrackService.getGtsAccountSettings(true).then(function (accountSettings) {
      _accountSettings = accountSettings;
    }).finally(function () {
      if (_accountSettings) {
        _temperatureUnit = _accountSettings.temperatureUnits === 0 ? '\xB0' + 'F' : '\xB0' + 'C';
        if (config.temperatureUnit === '') {
          config.temperatureUnit = _temperatureUnit;
        }

        if (config.max === null && config.min === null) {
          config.max = _accountSettings.temperatureUnits === 1 ? 10 : 50;
          config.min = _accountSettings.temperatureUnits === 1 ? -12 : 10;
        }
        if (TempMonitoringService.getTemperatureRangeValue() === null) {
          TempMonitoringService.saveIntialTmparatueRangeValues(_accountSettings.temperatureUnits);
        }

        var configurationCache = TempMonitoringService.getTemperatureConfiguration();
        if (configurationCache) {
          config.max = configurationCache.max;
          config.min = configurationCache.min;
        }

        //_initTempratureSetings();
      }
      $timeout(function () {
        $rootScope.$broadcast('reqDataUpdate');
      }, 0);
    });

    var consistencyTab = 5;

    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          $scope.temperatureDetail.date.startDate = moment($scope.temperatureDetail.date.startDate);
          $scope.temperatureDetail.date.endDate = moment($scope.temperatureDetail.date.endDate);
          config.startDate = $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
          config.endDate = $scope.temperatureDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
          _serverTimeFormat._tmpStartDate = config.startDate;
          _serverTimeFormat._tmpEndDate = config.endDate;
          if (config.deviceId) {
            $scope.reloadChartData = true;
			$scope.reloadFuelHistory = true;
            $scope.reloadConsistencyChartData = true;
            var loadConsistencyData = $scope.activeTab === consistencyTab;
            loadThermoOrConsistencyData(config.deviceId, config.startDate, config.endDate, loadConsistencyData);
			loadFuelHistory(config.deviceId, config.startDate);
          }
        }
      }
    };



    loadGtsAccountSettings();

    $scope.fuelTabInitialized = false;
    $scope.weightTabInitialized = false;
    $scope.consistencyTabClickInitialized = false;

    $scope.fuelTabClick = function () {
      _resetConstancyAutoRefresh(); // stop if any existing
      $timeout(function () {
        if ($scope.fuelTabInitialized === false) {
          $scope.fuelTabInitialized = true;
          // Initialize date range picker settings
          commonTrackService.getDatePickerDetails().then(function (settings) {
            $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
          });
        }


        // load the widget with correct data from the parent widget (current selected parent tab)
        // same behaviour like row click event ,
        if ($scope.parentWidgetData && $scope.parentWidgetData.widget) {
          $scope.reloadFuelHistory = false;
          var set = getSetData($scope.parentWidgetData.widget);
          _handleDataUpdate($scope.parentWidgetData.dashboardName, $scope.parentWidgetData.activeTab, set['tab_' + $scope.parentWidgetData.activeTab + '_selectedRow'].value, $scope.parentWidgetData.widget , $scope.activeTab);

        } else { // load the data based on gobal row ( first row of parent widget) // fall back , mostly not used .
          var loadDate = $scope.getDateState(); // gives global ( first row details of the parent widget) , which is wrong when differnt tabs are used in the parent tab
          if (loadDate) {
            loadFuelHistory($scope.getDeviceID(), loadDate.startDate);
          } else {
            loadFuelHistory($scope.getDeviceID(), _serverTimeFormat._tmpStartDate);
          }

          if ($scope.reloadChartData === true) {
            $scope.reloadChartData = false;

            var dateO = $scope.getDateState();
            if (dateO) {
              loadThermoData($scope.getDeviceID(), dateO.startDate, dateO.endDate);
            } else {
              loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
            }
          } else {
            $('#jqxFuelChart').jqxChart($scope.fuelChartSettings);
            $('#jqxFuelChart').jqxChart('refresh');
          }
        }

      }, 100);
    };

    $scope.weightTabClick = function () {
      _resetConstancyAutoRefresh();// stop if any existing
      // console.log('reloadChartData: ' + $scope.reloadChartData + ' id:' + $scope.getDeviceID());
      $timeout(function () {
        if ($scope.weightTabInitialized === false) {
          $scope.weightTabInitialized = true;
          // Initialize date range picker settings
          commonTrackService.getDatePickerDetails().then(function (settings) {
            $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
          });
        }
        if ($scope.reloadChartData === true) {
          var dateO = $scope.getDateState();
          if (dateO) {
            loadThermoData($scope.getDeviceID(), dateO.startDate, dateO.endDate);
          } else {
            loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
          }
          $scope.reloadChartData = false;
          $('#jqxWeightChart').jqxChart($scope.weightChartSettings);
          $('#jqxWeightChart').jqxChart('refresh');
        }

      }, 100);
    };

    $scope.consistencyTabClick = function () {
      if ($scope.consistencyTabClickInitialized === false) {
        $scope.consistencyTabClickInitialized = true;
        // Initialize date range picker settings
        commonTrackService.getDatePickerDetails().then(function (settings) {
          $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
        });
      }
      $timeout(function () {

         // load the widget with correct data from the parent widget (current selected parent tab)
        // same behaviour like row click event ,
        if ($scope.parentWidgetData && $scope.parentWidgetData.widget) {
          $scope.reloadConsistencyChartData = false;
          var set = getSetData($scope.parentWidgetData.widget);
          _handleDataUpdate($scope.parentWidgetData.dashboardName, $scope.parentWidgetData.activeTab, set['tab_' + $scope.parentWidgetData.activeTab + '_selectedRow'].value, $scope.parentWidgetData.widget, $scope.activeTab);

        } else { // fall back ,  mostly not used
          if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
            var currentState = stateManagerService.getGlobalStateData();
            var _tmpMomentDate = moment(currentState.endDate.value);
            _tmpMomentDate = _tmpMomentDate.subtract({ hours: (config.maxHours ? config.maxHours : 2) });
            _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
            _serverTimeFormat._tmpEndDate = currentState.endDate.value;
            $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
            $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
          }
          loadThermoOrConsistencyData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, true);
          $('#jqxConsistencyChart1').jqxChart($scope.consistencyChart1Settings);
          $('#jqxConsistencyChart1').jqxChart('hideSerie', 1, 0, NaN);
          $('#jqxConsistencyChart1').jqxChart('refresh');
          $('#jqxConsistencyChartWater').jqxChart($scope.consistencyChartWaterSettings);
          $('#jqxConsistencyChartWater').jqxChart('hideSerie', 1, 0, NaN);
          $('#jqxConsistencyChartWater').jqxChart('refresh');
          $('#jqxConsistencyChartTemperature').jqxChart($scope.consistencyChartTemperatureSettings);
          $('#jqxConsistencyChartTemperature').jqxChart('hideSerie', 1, 0, NaN);
          $('#jqxConsistencyChartTemperature').jqxChart('refresh');
          $('#jqxConsistencyChart2').jqxChart($scope.consistencyChart2Settings);
          $('#jqxConsistencyChart2').jqxChart('hideSerie', 1, 0, NaN);
          $('#jqxConsistencyChart2').jqxChart('refresh');
          $('#jqxConsistencyChart3').jqxChart($scope.consistencyChart3Settings);
          $('#jqxConsistencyChart3').jqxChart('refresh');
        }
      }, 100);
    };

    $scope.inputTabClick = function () {
      _resetConstancyAutoRefresh(); // stop if any existing
      if ($scope.reloadChartData === true) {
        $scope.reloadChartData = false;
        if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
          var currentState = stateManagerService.getGlobalStateData();
          var _tmpMomentDate = moment(currentState.endDate.value);
          _tmpMomentDate = _tmpMomentDate.subtract({ hours: (config.maxHours ? config.maxHours : 2) });
          _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
          _serverTimeFormat._tmpEndDate = currentState.endDate.value;
          $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
          $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
        }
        loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
      }
      $scope.initInputTab();

    };

    $scope.tempTabClick = function () {
      _resetConstancyAutoRefresh(); // stop if any existing
      if ($scope.reloadChartData === true) {
        $scope.reloadChartData = false;
        if (!_serverTimeFormat._tmpStartDate || !_serverTimeFormat._tmpEndDate) {
          var currentState = stateManagerService.getGlobalStateData();
          var _tmpMomentDate = moment(currentState.endDate.value);
          _tmpMomentDate = _tmpMomentDate.subtract({ hours: (config.maxHours ? config.maxHours : 2) });
          _serverTimeFormat._tmpStartDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
          _serverTimeFormat._tmpEndDate = currentState.endDate.value;
          $scope.temperatureDetail.date.startDate = moment(_serverTimeFormat._tmpStartDate);
          $scope.temperatureDetail.date.endDate = moment(_serverTimeFormat._tmpEndDate);
        }
        loadThermoData($scope.getDeviceID(), _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate);
      }
      if (!$scope.tempRangeInit) {
        $timeout(function () {
          $scope.initTempTab();
          $('#tempRangeselctor').jqxRangeSelector('refresh');
          $scope.tempRangeInit = true;

        }, 0);
      } else {
        $scope.initTempTab();
      }

      $timeout(function () { window.$('#temperatureChartContainer').jqxChart('refresh'); }, 50);
    };

    $scope.$watch('temperatureDetail.date', function () {
      var loadConsistencyData = $scope.activeTab === consistencyTab;
      var initialLoadDone = (loadConsistencyData && $scope.consistencyDataLoaded) || (!loadConsistencyData && $scope.thermoDataLoaded);
      if (initialLoadDone && !$scope.ignoreDateWatch) { // trigger the call only after initial loading is done , not before
        $scope.reloadChartData = true;
		$scope.reloadFuelHistory = true;
        $scope.reloadConsistencyChartData = true;
        $scope.temperatureDetail.date.startDate = moment($scope.temperatureDetail.date.startDate);
        $scope.temperatureDetail.date.endDate = moment($scope.temperatureDetail.date.endDate);
        loadThermoOrConsistencyData($scope.getDeviceID(), $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss'), $scope.temperatureDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss'), loadConsistencyData);
		loadFuelHistory(config.deviceId, $scope.temperatureDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss'));
      }

      $scope.ignoreDateWatch = false;
    });

    $scope.getDeviceID = function () {

      var currentState = stateManagerService.getGlobalStateData();
      if (currentState && currentState.deviceID) {
        var deviceID = currentState.deviceID.value;
        if (deviceID) {
          //return deviceID;
           $scope.parentWidgetData.deviceID = deviceID;
        }
      }
      //return null;
      if ( $scope.parentWidgetData.deviceID) {
        return  $scope.parentWidgetData.deviceID;
      } else {
        return null;
      }
    };

    $scope.getDateState = function () {
      var dateO = {};

      var currentState = stateManagerService.getGlobalStateData();

      if (currentState) {
        //dateO.startDate = currentState.startDate.value;
        dateO.endDate = currentState.endDate.value;
        var _tmpMomentDate = moment(currentState.endDate.value);
        _tmpMomentDate = _tmpMomentDate.subtract({ hours: (config.maxHours ? config.maxHours : 2) });
        dateO.startDate = _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');


      } else {
        return null;
      }

      return dateO;
    };

    $scope.initInputTab = function () {
      $timeout(function () {

        // Initialize date range picker settings
        commonTrackService.getDatePickerDetails().then(function (settings) {
          $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
        });

        // prepare jqxChart settings
        var source = $scope.doorStatusChartSettings.source;
        $scope.doorStatusChartSettings = commonTrackService.getJqxLineChartSettings();
        $scope.doorStatusChartSettings.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusChartTitle');
        $scope.doorStatusChartSettings.xAxis = {
          valuesOnTicks: true,
          dataField: 'time',
          tickMarks: { visilbe: true }
        };
        $scope.doorStatusChartSettings.seriesGroups = [
          {
            type: 'stepline',
            valueAxis: {
              flip: false,
              title: { text: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusChartY') },
              unitInterval: 1,
              formatFunction: function (value) {
                if (value === 0) {
                  return $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusYMinValue');
                }
                if (value === 1) {
                  return $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorStatusYMaxValue');
                }
              },
              labels: { horizontalAlignment: 'right' }
            },
            series: [
              {
                dataField: 'din1',
                displayText: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.din1'),
                lineWidth: 1,
                symbolSize: 6,
                toolTipFormatFunction: function (value, index, valueData, functionObj, xVlaue) {
                  var _time = '<div>' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.time') + ':' + ' ' + xVlaue + '</div>';
                  if (value === 0) {
                    return _time + '<div>' + valueData.displayText + ':' + ' ' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.closed') + '</div>';
                  }
                  if (value === 1) {
                    return _time + '<div>' + valueData.displayText + ':' + ' ' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.open') + '</div>';
                  }
                }
              }]
          }
        ];
        $scope.doorStatusChartSettings.source = source;
        //window.$('#doorChartContainer').jqxChart('refresh');
        window.$('#doorChartContainer').jqxChart($scope.doorStatusChartSettings);
        window.$('#doorChartContainer').jqxChart('refresh');
        $scope.inputInit = true;

      }, 0);

    };



    $scope.toggleContent = function (section) {
      switch (section) {
        case 'VehicleInfo':
          $scope.summaryCardData.showVehicleInfoContent = !$scope.summaryCardData.showVehicleInfoContent;
          break;
        case 'VehicleState':
          $scope.summaryCardData.showVehicleStateContent = !$scope.summaryCardData.showVehicleStateContent;
          break;
        case 'CurrentJob':
          $scope.summaryCardData.showCurrentJobContent = !$scope.summaryCardData.showCurrentJobContent;
          break;
        case 'Maintenance':
          $scope.summaryCardData.showMaintenanceContent = !$scope.summaryCardData.showMaintenanceContent;
          break;
      }
    };

    $scope.initSummaryTab = function () {
      _resetConstancyAutoRefresh();      // stop if any existing

      var currentState = stateManagerService.getGlobalStateData();
      if (currentState && currentState.deviceID) {

        var deviceID = currentState.deviceID.value;
        if (!currentState.deviceID.value) {
          var tabHackString = 'tab_0_selectedRow';
          var rowData = currentState[tabHackString];
          if (rowData) {
            deviceID = rowData.value.deviceid;
          }
        }
        $scope.summaryCardData.isloading = true;

        if (deviceID) {
          TempMonitoringService.getSummaryDetails(deviceID).then(function (data) {
            // setup bindings
            $scope.isSummaryAuthed = true;
            if (data.dataList) {
              $scope.summaryData = data.dataList[0];
              $scope.summaryData.isStartTime = $scope.summaryData.starttimestamp > $scope.summaryData.stoptimestamp;

              $scope.summaryCardData.hasCurrentJob = $scope.summaryData.orderid !== '';

              if ($scope.summaryData.datetime === '') {
                $scope.summaryData.datetime = '---';
              }

              if ($scope.summaryData.lasttachodownloadtime === '') {
                $scope.summaryData.lasttachodownloadtime = '---';
              }

              if ($scope.summaryData.workorderstarttime === '') {
                $scope.summaryData.workorderstarttime = '---';
              }

              if ($scope.summaryData.workorderdeparturetime === '') {
                $scope.summaryData.workorderdeparturetime = '---';
              }

              if ($scope.summaryData.workorderarrivaltime === '') {
                $scope.summaryData.workorderarrivaltime = '---';
              }

              if ($scope.summaryData.workorderdischargestarttime === '') {
                $scope.summaryData.workorderdischargestarttime = '---';
              }

              if ($scope.summaryData.workorderdischargeendtime === '') {
                $scope.summaryData.workorderdischargeendtime = '---';
              }

              if ($scope.summaryData.workorderreturntime === '') {
                $scope.summaryData.workorderreturntime = '---';
              }
            }

          }, function () {
            $scope.isSummaryAuthed = false;

          }).finally(function () {
            $scope.summaryCardData.isloading = false;
          });
        }
      }
    };

    $scope.initTempTab = function () {
      _resetConstancyAutoRefresh(); // stop if any existing

      commonTrackService.getDatePickerDetails().then(function (settings) {
        $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings, 'EventSummaryCharts'));
      });
      var _tmpMaxRange = _accountSettings.temperatureUnits === 0 ? 50 : 12;
      var _tmpMinRange = _accountSettings.temperatureUnits === 0 ? 10 : -12.0;
      $scope.rangeSelectorSettings = {
        height: 4,
        min: config.min && config.temperatureUnit === _temperatureUnit ? Number(config.min) : _tmpMinRange,
        max: config.max && config.temperatureUnit === _temperatureUnit ? Number(config.max) : _tmpMaxRange,
        range: $scope.rangeSelection,
        labelsFormatFunction: function (value) {
          return value + _temperatureUnit;
        },

        majorTicksInterval: 2,
        minorTicksInterval: 2,
        markersFormatFunction: function (value) {
          return value + _temperatureUnit;
        }
      };

      var source = $scope.tempratursChartHistory.source;
      $scope.tempratursChartHistory = commonTrackService.getJqxLineChartSettings();
      $scope.tempratursChartHistory.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryTitle');
      $scope.tempratursChartHistory.xAxis = {
        valuesOnTicks: true,
        dataField: 'time',
        tickMarks: { visilbe: true }
      };
      $scope.tempratursChartHistory.seriesGroups = $scope.tempSeriesGroups;
      $scope.tempratursChartHistory.source = source;

      $timeout(function () {
        window.$('#tempRangeselctor').jqxRangeSelector('refresh');
        window.$('#temperatureChartContainer').jqxChart('refresh');
      }, 100);
      $scope.tempInit = true;
      $scope.tempDataLoadingFinished = true;

    };

	var getLastWeekRange = function (endDate) {
		var startDate = moment(endDate, 'YYYY/MM/DD/HH:mm:ss').subtract(6,'d');
	    startDate = startDate.startOf('day').format('YYYY/MM/DD/HH:mm:ss');
	    endDate = moment(endDate, 'YYYY/MM/DD/HH:mm:ss').endOf('day').format('YYYY/MM/DD/HH:mm:ss');

		var range = {
          startDate: startDate,
          endDate: endDate
        };
		return range;
	};

	$scope.showDailyDistanceReport = function () {
	  var deviceID = $scope.getDeviceID();
	  var dateO =  $scope.getDateState();
	  var endDate = dateO ? dateO.endDate :  _serverTimeFormat._tmpEndDate;
      // Get fuel history for the last 7 days (including today)
	  var range = getLastWeekRange(endDate);

      $state.go('reports.vehicleDetail', {
        'reportName': 'DailyDistanceDetail',
        'vehicleId': deviceID,
        'dateFrom': range.startDate,
        'dateTo': range.endDate,
		'hasCustomDateRange': true
      });
    };


    var dataStateUpdateListener = $scope.$on('dataStateUpdate', function (event, data) {



      // summary tab open
      var set;
      // save the parent widget details in order to user it latter when switcing the tab .
      $scope.parentWidgetData.dashboardName = data.dashboardName;
      $scope.parentWidgetData.widget = data.widget;
      $scope.parentWidgetData.activeTab = data.activeTab;

      if ($scope.activeTab === 0) {
        $scope.initSummaryTab();
        $scope.reloadChartData = true;
		    $scope.reloadFuelHistory = true;
        $scope.reloadConsistencyChartData = true;
      } else if ($scope.activeTab === 5) {

        // if the auto refresh running and no user row cick detected skip those evenets from the vehicleList grid
        if($scope.consitancytab.hasAutoRefresh &&  !data.rowSelectOriginalEvent){
          return ;
        }
        // if row select is from the user then reset he checkbox and refresh count
        _resetConstancyAutoRefresh();

        if ($scope.isWidgetPostInitFinished) {
           set = getSetData(data.widget);
          _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
        }
      }
      else {
        if ($scope.isWidgetPostInitFinished) {
            set = getSetData(data.widget);
          _handleDataUpdate(data.dashboardName, data.activeTab, set['tab_' + data.activeTab + '_selectedRow'].value, data.widget);
        } else {
          //console.log('Ignoring dataState update from widget: ' + data.widget);
        }
      }
    });

    // Uncheck the auto Refresh check box and stop any running auto refresh
    function _resetConstancyAutoRefresh(){
      $scope.consitancytab.hasAutoRefresh = 0;
      $scope.stopConsistancyAutoRefresh();
      $scope.consistancyConter = consistancyRefreshIntervalValue;
    }

    var getSetData = function (widget) {
      var loginID = AuthenticationService.GetLoginID();
      widget = loginID.Account + '_' + loginID.username + '_' + widget;
      var stateData = stateManagerService.getStateData();
      var set = stateData && stateData[widget] ? stateData[widget] : {};
      return set;
    };


    function _intRequestData(event, data, currentActiveTab) {



      if ( (data.selectedRow !== null && data.selectedRow !== undefined || event && event.name && event.name === 'ordersRowSelected')) {
        var _tmpMomentDate;
        if (data.selectedRow && !data.startDate && !data.endDate) {
          var _tmpTimeArray = data.selectedRow.time.split(':');
          if (data.selectedRow.date.indexOf('/') > -1) {
            _tmpMomentDate = moment(data.selectedRow.date, 'DD/MM/YYYY');
          } else {
            _tmpMomentDate = moment(data.selectedRow.date);
          }
          _tmpMomentDate.set({
            hour: Number(_tmpTimeArray[0]),
            minute: Number(_tmpTimeArray[1]),
            second: Number(_tmpTimeArray[2])
          });
          _tmpMomentDate.subtract({ hours: config.maxHours });
        }

        _serverTimeFormat._tmpEndDate = event && event.name && event.name === 'ordersRowSelected' && data.endDate ? data.endDate : commonTrackService.formatReportDateTime(data.selectedRow.date, data.selectedRow.time);
        _serverTimeFormat._tmpStartDate = event && event.name && event.name === 'ordersRowSelected' && data.startDate ? data.startDate : _tmpMomentDate.format('YYYY/MM/DD/HH:mm:ss');
        $scope.doorStatusChartSettings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
        $scope.tempratursChartHistory.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
        //$scope.consistencyChart1Settings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
        //$scope.consistencyChartWaterSettings.description = _serverTimeFormat._tmpStartDate + ' - ' + _serverTimeFormat._tmpEndDate;
        if (data.selectedRow && data.selectedRow.deviceid || event && event.name && event.name === 'ordersRowSelected' && data.repoVehicle) {
          config.deviceId = event && event.name && event.name === 'ordersRowSelected' && data.repoVehicle ? data.repoVehicle : data.selectedRow.deviceid;
           $scope.parentWidgetData.deviceID = config.deviceId;
          $scope.temperatureDetail = {
            date: {
              startDate: new Date(_serverTimeFormat._tmpStartDate),
              endDate: new Date(_serverTimeFormat._tmpEndDate)
            }
          };
          if (currentActiveTab !== undefined) {
            switch (currentActiveTab) {
              case 4:
                loadFuelHistory(config.deviceId, _serverTimeFormat._tmpStartDate);
                loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
                break;
              case 5:
                loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
                break;
            }
          } else {
            loadThermoOrConsistencyData(config.deviceId, _serverTimeFormat._tmpStartDate, _serverTimeFormat._tmpEndDate, $scope.activeTab === consistencyTab);
            loadFuelHistory(config.deviceId, _serverTimeFormat._tmpStartDate);
          }

        }
      }
    }

    function tempratureToolTipfomat(value, index, valueData, functionObj, xVlaue) {
      var _time = '<div>' + $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.time') + ':' + ' ' + xVlaue + '</div>';
      return _time + '<div>' + valueData.displayText + ':' + ' ' + value + _temperatureUnit + '</div>';
    }

    var loadThermoData = function (deviceId, startDate, endDate) {
      loadThermoOrConsistencyData(deviceId, startDate, endDate, false);
    };

    var colorWhiteHex1 = '#ffffff';
    var colorWhiteHex2 = '#FFFFFF';

    var loadThermoOrConsistencyData = function (deviceId, startDate, endDate, loadConsistencyData) {
      $scope.isDataNotAvailable = false;
      $scope.isNotSummaryChartsAuthorized = false;
      $scope.thermoDataLoading = true;
      $scope.thermoDataLoaded = false;
      $scope.consistencyDataLoaded = false;
      if (deviceId) {
        TempMonitoringService.getThermoEventDatalList(deviceId, startDate, endDate, loadConsistencyData).then(function (data) {
          var _tmpData = data.dataList;
          if (loadConsistencyData) {
            $('#jqxConsistencyLegend').empty();
            $scope.consistencyDataLoaded = true;
          } else {
            $scope.thermoDataLoaded = true;
          }
          var series = [];
          // SCL-4331: handle job status transitions
          var previousJobStatus = '';
          var timeBands = [];
          var bandLegends = new Map();
          // LOADING_START, DISCHARGE_START, DISCHARGE_STOP, JOB_RETURN, JOB_BACK, MIXERDRUM_TURNRIGHT
          // JOB_BS_DRIVE, JOB_START, JOB_ARRIVE, JOB_DEPART, INPUT_ON_00, INPUT_OFF_00
          var allowedStatusCodeLegends = new Array(4097, 4101, 4102, 4103, 4104, 4112, 4113, 61831, 61973, 62005, 62496, 62528);


          // jqx chart data accepts only nmbers so change 'On|Off' to '1|0' && Thermo values to float .
          for (var i = 0; i < _tmpData.length; i++) {
            _tmpData[i].timeindex = i;
            if (_tmpData[i].din1 === 'Aus' || _tmpData[i].din1 === 'Off' || _tmpData[i].din1 === $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorClose')) {
              _tmpData[i].din1 = 0;
            }
            if (_tmpData[i].din1 === 'An' || _tmpData[i].din1 === 'On' || _tmpData[i].din1 === $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.doorOpen')) {
              _tmpData[i].din1 = 1;
            }

            if (!loadConsistencyData) {
              for (var j = 1; j <= 8; j++) {

                if (_tmpData[i]['thermo' + j].indexOf('F') !== -1) {
                  _tmpData[i]['thermo' + j] = _tmpData[i]['thermo' + j].replace('F', '');
                }
                if (_tmpData[i]['thermo' + j].indexOf('C') !== -1) {
                  _tmpData[i]['thermo' + j] = _tmpData[i]['thermo' + j].replace('C', '');
                }
                if (_tmpData[i]['thermo' + j] === '--') {
                  _tmpData[i]['thermo' + j] = null;
                }
              }
            }


            if (loadConsistencyData && _tmpData[i].jobstatusdesc) {
              if (_tmpData[i].jobstatusdesc !== previousJobStatus && allowedStatusCodeLegends.includes(_tmpData[i].jobstatuscode)) {
                var linecolor = 'black';
                // Use the background or foreground color if it is not white (colorWhiteHex1 or colorWhiteHex2)
                if (_tmpData[i].jobstatusdescBgColor && _tmpData[i].jobstatusdescBgColor !== colorWhiteHex1 && _tmpData[i].jobstatusdescBgColor !== colorWhiteHex2) {
                  linecolor = _tmpData[i].jobstatusdescBgColor;
                } else if (_tmpData[i].jobstatusdescColor && _tmpData[i].jobstatusdescColor !== colorWhiteHex1 && _tmpData[i].jobstatusdescColor !== colorWhiteHex2) {
                  linecolor = _tmpData[i].jobstatusdescColor;
                }
                timeBands.push({ minValue: _tmpData[i].timeindex, maxValue: _tmpData[i].timeindex + 0.1, fillColor: linecolor, lineWidth: 2, opacity: 1 });
                bandLegends.set(_tmpData[i].jobstatusdesc, linecolor);
                previousJobStatus = _tmpData[i].jobstatusdesc;
              }
            }
          }

          for (var noOfSeries = 1; noOfSeries <= 8; noOfSeries++) {
            series.push({
              dataField: 'thermo' + noOfSeries,
              displayText: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.thermo' + noOfSeries),
              lineWidth: 1,
              symbolSize: 6,
              toolTipFormatFunction: tempratureToolTipfomat
            });
          }
          //_temperatureUnit = '\xB0F'; //  used fot testing below values .
          var _localStorageTempRange = TempMonitoringService.getTemperatureRangeValue();
          _localStorageTempRange = _accountSettings.temperatureUnits === 0 ? _localStorageTempRange.f : _localStorageTempRange.c;

          var tempMinRange = _accountSettings && _accountSettings.temperatureUnits === 0 ? 10 : -12.0;
          var tempMaxRange = _accountSettings && _accountSettings.temperatureUnits === 0 ? 50 : 10.0;
          var unitInterval = _accountSettings && _accountSettings.temperatureUnits === 0 ? 5 : 2;


          if ((config.max && !_localStorageTempRange || _localStorageTempRange && _localStorageTempRange.to && config.max !== _localStorageTempRange.to) || (config.min && !_localStorageTempRange || _localStorageTempRange && _localStorageTempRange.from && config.min !== _localStorageTempRange.from)) {
            var _from = _localStorageTempRange && _localStorageTempRange.from >= Number(config.min) ? _localStorageTempRange.from : Number(config.min);
            var _to = _localStorageTempRange && _localStorageTempRange.to <= Number(config.max) ? _localStorageTempRange.to : Number(config.max);
            if (_from < _to) {
              $scope.rangeSelection.from = _from;
              $scope.rangeSelection.to = _to;
            }
            else {
              $scope.rangeSelection.from = tempMinRange;
              $scope.rangeSelection.to = tempMaxRange;
            }
          } else {
            $scope.rangeSelection.from = _localStorageTempRange ? _localStorageTempRange.from : tempMinRange;
            $scope.rangeSelection.to = _localStorageTempRange ? _localStorageTempRange.to : tempMaxRange;
          }

          var rangeValue = TempMonitoringService.getTemperatureRangeValue();
          if (rangeValue) {
            if (rangeValue.c) {
              tempMinRange = rangeValue.c.from;
              tempMaxRange = rangeValue.c.to;
            } else if (rangeValue.f) {
              tempMinRange = rangeValue.f.from;
              tempMaxRange = rangeValue.f.to;
            }
            //
            if (tempMinRange < Number(config.min)) {
              tempMinRange = Number(config.min);
            }

            if (tempMaxRange > Number(config.max)) {
              tempMaxRange = Number(config.max);
            }
          }
          $scope.tempratursChartHistory.title = $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryTitle');
          $scope.tempratursChartHistory.seriesGroups = [
            {
              type: 'line',
              valueAxis: {
                flip: false,
                title: { text: $translate.instant('dashBoard.fleetManagement.tempMonitoringWidget.temperatureHistoryYAxis') },
                unitInterval: unitInterval,
                minValue: config.min && config.temperatureUnit === _temperatureUnit && !rangeValue ? Number(config.min) : tempMinRange, // if temperature unit  is 'F'  min range  value 10 | 12.2
                maxValue: config.max && config.temperatureUnit === _temperatureUnit && !rangeValue ? Number(config.max) : tempMaxRange,// if temperature unit is 'F' max range value 50 |10.0
                formatFunction: function (value) {
                  return value + _temperatureUnit;
                },
                labels: {
                  horizontalAlignment: 'right'
                }
              },
              series: series
            }
          ];

          if (loadConsistencyData) {
          [$scope.consistencyChart1Settings, $scope.consistencyChartWaterSettings, $scope.consistencyChartTemperatureSettings, $scope.consistencyChart2Settings, $scope.consistencyChart3Settings].forEach(function(settings) {
              settings.source = _tmpData;
              settings.xAxis.bands = timeBands;
            });
            $scope.consistencyDataSource = _tmpData;

            // SCL-4331: render job-status legends
            bandLegends.forEach(function (statusColour, statusText) {
              var legendItem = '<div style ="float: left;padding-left:10px;"><span style="background-color:' + statusColour +
                ';width:1.0rem;height:1.0rem;display: inline-block;"></span><span class="jqx-chart-legend-text" style ="padding-left:5px;">' + statusText + '</span></div>';
              $('#jqxConsistencyLegend').append(legendItem);
            });

            //Bugfix 106911/109006/108934
            //Set the min and the max for Water flow chart axes (both axis on the left and the right)
            var minWaterinputconverted = Math.min.apply(Math, _tmpData.map(function(o) { return o.waterinputconverted; }));
            var maxWaterinputconverted = Math.max.apply(Math, _tmpData.map(function(o) { return o.waterinputconverted; }));
            var waterInputconvertedPercent = (maxWaterinputconverted - (minWaterinputconverted)) * (5/100);
            if (minWaterinputconverted === maxWaterinputconverted && maxWaterinputconverted !== 0) {
              if (maxWaterinputconverted > 0) {
                waterInputconvertedPercent = maxWaterinputconverted * 0.5;
              } else {
                waterInputconvertedPercent = maxWaterinputconverted * -0.5;
              }
            }
            $scope.consistencyChartWaterSettings.seriesGroups[0].valueAxis.minValue = minWaterinputconverted - waterInputconvertedPercent;
            $scope.consistencyChartWaterSettings.seriesGroups[0].valueAxis.maxValue = maxWaterinputconverted + waterInputconvertedPercent;

            var minWaterinputraw = Math.min.apply(Math, _tmpData.map(function(o) { return o.waterinputraw; }));
            var maxWaterinputraw = Math.max.apply(Math, _tmpData.map(function(o) { return o.waterinputraw; }));
            var waterInputrawPercent = (maxWaterinputraw - minWaterinputraw) * (5/100);
            if (minWaterinputraw === maxWaterinputraw && maxWaterinputraw !== 0) {
              if (maxWaterinputraw > 0) {
                waterInputrawPercent = maxWaterinputraw * 0.5;
              } else {
                waterInputrawPercent = maxWaterinputraw * -0.5;
              }
            }
            $scope.consistencyChartWaterSettings.seriesGroups[1].valueAxis.minValue = minWaterinputraw - waterInputrawPercent;
            $scope.consistencyChartWaterSettings.seriesGroups[1].valueAxis.maxValue = maxWaterinputraw + waterInputrawPercent;

            //Set the min and the max for drum chart axes (both axis on the left and the right)
            var minCargoRotation = Math.min.apply(Math, _tmpData.map(function(o) { return o.cargorotation; }));
            var maxCargoRotation = Math.max.apply(Math, _tmpData.map(function(o) { return o.cargorotation; }));
            var cargoRotationPercent = (maxCargoRotation - minCargoRotation) * (5/100);
            if (minCargoRotation === maxCargoRotation && maxCargoRotation !== 0) {
              if (maxCargoRotation > 0) {
                cargoRotationPercent = maxCargoRotation * 0.5;
              } else {
                cargoRotationPercent = maxCargoRotation * -0.5;
              }
            }
            $scope.consistencyChart2Settings.seriesGroups[0].valueAxis.minValue = minCargoRotation - cargoRotationPercent;
            $scope.consistencyChart2Settings.seriesGroups[0].valueAxis.maxValue = maxCargoRotation + cargoRotationPercent;

            var minEnginerpm = Math.min.apply(Math, _tmpData.map(function(o) { return o.enginerpm; }));
            var maxEnginerpm = Math.max.apply(Math, _tmpData.map(function(o) { return o.enginerpm; }));
            var engineRpmPercent = (maxEnginerpm - minEnginerpm) * (5/100);
            if (minEnginerpm === maxEnginerpm && maxEnginerpm !== 0) {
              if (maxEnginerpm > 0) {
                engineRpmPercent = maxEnginerpm * 0.5;
              } else {
                engineRpmPercent = maxEnginerpm * -0.5;
              }
            }
            $scope.consistencyChart2Settings.seriesGroups[1].valueAxis.minValue = minEnginerpm - engineRpmPercent;
            $scope.consistencyChart2Settings.seriesGroups[1].valueAxis.maxValue = maxEnginerpm + engineRpmPercent;

            //Set the min and the max for oil input axes (both axis on the left and the right)
            var minOilinputconverted = Math.min.apply(Math, _tmpData.map(function(o) { return o.oilinputconverted; }));
            var maxOilinputconverted = Math.max.apply(Math, _tmpData.map(function(o) { return o.oilinputconverted; }));
            var oilInputConvertedPercent = (maxOilinputconverted - minOilinputconverted) * (5/100);
            if (maxOilinputconverted === minOilinputconverted && maxOilinputconverted !== 0) {
              if (maxOilinputconverted > 0) {
                oilInputConvertedPercent = maxOilinputconverted * 0.5;
              } else {
                oilInputConvertedPercent = maxOilinputconverted * -0.5;
              }
            }
            $scope.consistencyChart1Settings.seriesGroups[0].valueAxis.minValue = minOilinputconverted - oilInputConvertedPercent;
            $scope.consistencyChart1Settings.seriesGroups[0].valueAxis.maxValue = maxOilinputconverted + oilInputConvertedPercent;

            var minOilinputraw = Math.min.apply(Math, _tmpData.map(function(o) { return o.oilinputraw; }));
            var maxOilinputraw = Math.max.apply(Math, _tmpData.map(function(o) { return o.oilinputraw; }));
            var oilInputRawPercent = (maxOilinputraw - minOilinputraw) * (5/100);
            if (maxOilinputraw === minOilinputraw && maxOilinputraw !== 0) {
              if (maxOilinputraw > 0) {
                oilInputRawPercent = maxOilinputraw * 0.5;
              } else {
                oilInputRawPercent = maxOilinputraw * -0.5;
              }
            }
            $scope.consistencyChart1Settings.seriesGroups[1].valueAxis.minValue = minOilinputraw - oilInputRawPercent;
            $scope.consistencyChart1Settings.seriesGroups[1].valueAxis.maxValue = maxOilinputraw + oilInputRawPercent;
            
            //Set the min and the max for hydraulic oil temperature input axes (both axis on the left and the right)
            var minHydraulicTemperatureconverted = Math.min.apply(Math, _tmpData.map(function(o) { return o.hydraulicoiltemperatureinputconverted; }));
            var maxHydraulicTemperatureconverted = Math.max.apply(Math, _tmpData.map(function(o) { return o.hydraulicoiltemperatureinputconverted; }));
            var hydraulicTemperatureconvertedPercent = (maxHydraulicTemperatureconverted - minHydraulicTemperatureconverted) * (5/100);
            if (minHydraulicTemperatureconverted === maxHydraulicTemperatureconverted && maxHydraulicTemperatureconverted !== 0) {
              if (maxHydraulicTemperatureconverted > 0) {
                hydraulicTemperatureconvertedPercent = maxHydraulicTemperatureconverted * 0.5;
              } else {
                hydraulicTemperatureconvertedPercent = maxHydraulicTemperatureconverted * -0.5;
              }
            }
            $scope.consistencyChartTemperatureSettings.seriesGroups[0].valueAxis.minValue = minHydraulicTemperatureconverted - hydraulicTemperatureconvertedPercent;
            $scope.consistencyChartTemperatureSettings.seriesGroups[0].valueAxis.maxValue = maxHydraulicTemperatureconverted + hydraulicTemperatureconvertedPercent;

            var minHydraulicTemperatureRaw = Math.min.apply(Math, _tmpData.map(function(o) { return o.hydraulicoiltemperatureinputraw; }));
            var maxHydraulicTemperatureRaw = Math.max.apply(Math, _tmpData.map(function(o) { return o.hydraulicoiltemperatureinputraw; }));
            var hydraulicTemperaturePercent = (maxHydraulicTemperatureRaw - minHydraulicTemperatureRaw) * (5/100);
            if (minHydraulicTemperatureRaw === maxHydraulicTemperatureRaw && maxHydraulicTemperatureRaw !== 0) {
              if (maxHydraulicTemperatureRaw > 0) {
                hydraulicTemperaturePercent = maxHydraulicTemperatureRaw * 0.5;
              } else {
                hydraulicTemperaturePercent = maxHydraulicTemperatureRaw * -0.5;
              }
            }
            $scope.consistencyChartTemperatureSettings.seriesGroups[1].valueAxis.minValue = minHydraulicTemperatureRaw - hydraulicTemperaturePercent;
            $scope.consistencyChartTemperatureSettings.seriesGroups[1].valueAxis.maxValue = maxHydraulicTemperatureRaw + hydraulicTemperaturePercent;

            //Set the min and the max for ambient temp axes (both axis on the left and the right)
            var minAmbienttemp = Math.min.apply(Math, _tmpData.map(function(o) { return o.ambienttemp ? o.ambienttemp.replace(/[A-Za-z]/g, '') : Infinity; }));
            var maxAmbienttemp = Math.max.apply(Math, _tmpData.map(function(o) { return o.ambienttemp ? o.ambienttemp.replace(/[A-Za-z]/g, ''): -Infinity; }));
            if (minAmbienttemp !== Infinity && maxAmbienttemp !== -Infinity) {
              var ambientTempPercent = (maxAmbienttemp - minAmbienttemp) * (5/100);
              if (minAmbienttemp === maxAmbienttemp && maxAmbienttemp !== 0) {
                if (maxAmbienttemp > 0) {
                  ambientTempPercent = maxAmbienttemp * 0.5;
                } else {
                  ambientTempPercent = maxAmbienttemp * -0.5;
                }
              }
              $scope.consistencyChart3Settings.valueAxis.minValue = minAmbienttemp - ambientTempPercent;
              $scope.consistencyChart3Settings.valueAxis.maxValue = maxAmbienttemp + ambientTempPercent;
            }
          } else {
            $scope.tempSeriesGroups = $scope.tempratursChartHistory.seriesGroups;
            $scope.thermoDataSource = _tmpData;
            $scope.doorStatusChartSettings.source = _tmpData;
            $scope.tempratursChartHistory.source = _tmpData;
            $scope.weightChartSettings.source = _tmpData;
            $scope.fuelChartSettings.source = _tmpData;

            if (!$scope.thermoDataAdapter) {
              $scope.thermoDataAdapter = new $.jqx.dataAdapter($scope.thermoDataSource, { autoBind: true });
            }
          }


        }, function (response) {
          if (errorHandlingService.errorForNoAuthorized(response)) {
            $scope.isNotSummaryChartsAuthorized = true;
          }
        }).finally(function () {
          $scope.thermoDataLoading = false;
          $scope.dataLoadingFinished = true;
          $scope.tempDataLoadingFinished = true;
          $timeout(function () {

            $scope.ignoreDateWatch = true;
            $scope.temperatureDetail.date = {
              startDate: moment(startDate),
              endDate: moment(endDate)
            };
            var description = moment(startDate).format('YYYY/MM/DD/HH:mm:ss') + ' - ' + moment(endDate).format('YYYY/MM/DD/HH:mm:ss');

            if (loadConsistencyData) {
              $scope.consistencyChart1Settings.description = description;
            $scope.consistencyChartWaterSettings.description = description;
            $scope.consistencyChartTemperatureSettings.description = description;
              $('#jqxConsistencyChart1').jqxChart($scope.consistencyChart1Settings);
              $('#jqxConsistencyChartWater').jqxChart($scope.consistencyChartWaterSettings);			  
              $('#jqxConsistencyChartTemperature').jqxChart($scope.consistencyChartTemperatureSettings);
              $('#jqxConsistencyChart2').jqxChart($scope.consistencyChart2Settings);
              $('#jqxConsistencyChart3').jqxChart($scope.consistencyChart3Settings);
            } else {
              $scope.weightChartSettings.description = description;
              $scope.fuelChartSettings.description = description;
              $('#jqxWeightChart').jqxChart($scope.weightChartSettings);
              $('#jqxFuelChart').jqxChart($scope.fuelChartSettings);

              if ($scope.inputInit) {
                $('#doorChartContainer').jqxChart({ description: description });
                $('#doorChartContainer').jqxChart('refresh');
              }

              if ($scope.tempInit) {
                $('#temperatureChartContainer').jqxChart({ description: description });
                $('#temperatureChartContainer').jqxChart($scope.tempratursChartHistory);
              }
            }
          }, 0, false);
        });
      }
    };

	var loadFuelHistory = function (deviceId, endDate) {
      $scope.isFuelHistoryNotAvailable = false;
      $scope.isNotFuelSummaryAuthorized = false;
      $scope.fuelHistoryLoading = true;
      $scope.fuelHistoryLoaded = false;
      if (deviceId) {
	    // Get fuel history for the last 7 days (including today)
		var range = getLastWeekRange(endDate);

        TempMonitoringService.getFuelHistory(deviceId, range.startDate, range.endDate).then(function (data) {
        var _tmpData = data.dataList;
		if (_tmpData && _tmpData.length > 7) {
		  // Remove row with total values
          _tmpData = _tmpData.slice(0, 7);

          // Bug 106396 fix: ensure that all values are set
          for (var i = 0; i < _tmpData.length; i++) {
            _tmpData[i].date = moment(_tmpData[i].date, 'DD/MM/YYYY').format('YYYY-MM-DD');
          }
        }
        $scope.fuelHistoryLoaded = true;

		var description = moment(range.startDate).format('YYYY/MM/DD') + ' - ' +  moment(range.endDate).format('YYYY/MM/DD');
        $scope.fuelChart2Settings.source = _tmpData;
	    $scope.fuelChart2Settings.description = description;

      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isNotFuelSummaryAuthorized = true;
        }
        }).finally(function () {
          $scope.fuelHistoryLoading = false;
          $('#jqxFuelChart2').jqxChart($scope.fuelChart2Settings);
          $('#jqxFuelChart2').jqxChart('refresh');
        });
      }
    };

    $timeout(function () {
      if (TempMonitoringService.getRowEventStatus()) {
        if ($scope.doorStatusChartSettings.seriesGroups.length === 0 || $scope.tempratursChartHistory.seriesGroups.length === 0) {
          var _vehilceLastLocationData = commonTrackService.getsetLastLocatioWidgetData();

          if (_vehilceLastLocationData && _vehilceLastLocationData.selectedRow && _vehilceLastLocationData.selectedRow.deviceid) {
            _intRequestData(undefined, _vehilceLastLocationData);
          }
        }
      }
    }, 100);

    $timeout(function () {
      $scope.$on('tempRangeChange', function () {
        if ($scope.tempDataLoadingFinished && $scope.tempratursChartHistory.seriesGroups) {
          var rangeValue = $('#tempRangeselctor').jqxRangeSelector('getRange');
          $scope.tempratursChartHistory.seriesGroups[0].valueAxis.minValue = rangeValue.from;
          $scope.tempratursChartHistory.seriesGroups[0].valueAxis.maxValue = rangeValue.to;
          TempMonitoringService.saveTempRangeValues(rangeValue, _accountSettings.temperatureUnits);
          $('#temperatureChartContainer').jqxChart('refresh');
        }
      });
    }, 50);

    var maxGetInitialDataRetries = 30;
    var currentParentRowResEvent = $scope.$on('resDataUpdate', function (event, data) {
      if (maxGetInitialDataRetries < 0 || $scope.isWidgetPostInitFinished) {
        currentParentRowResEvent();
        return;
      }
      //console.info('Temperature Widget Requesting Parent for Data ..');
      --maxGetInitialDataRetries;
      var set = getSetData(data.widget);
      var selectedParentTabRowValues = set['tab_' + data.activeTab + '_selectedRow'];

      // parents First tab must always retrun a  valid selected row
      if ((data.activeTab === 0 && !_.isEmpty(selectedParentTabRowValues) && !_.isEmpty(selectedParentTabRowValues.value)) || (data.activeTab > 0 && !_.isEmpty(selectedParentTabRowValues))) {
        $scope.isWidgetPreInitFinished = true;
        $scope.isWidgetPostInitFinished = true;

        // save the parent widget details in order to user it latter when switcing the tab .
        $scope.parentWidgetData.dashboardName = data.dashboardName;
        $scope.parentWidgetData.widget = data.widget;
        $scope.parentWidgetData.activeTab = data.activeTab;

        _handleDataUpdate(data.dashboardName, data.activeTab, selectedParentTabRowValues.value, data.widget);

      } else {
        // Repeatedly try to get the data from parent .
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            if (!$scope.isWidgetPostInitFinished) {
              $rootScope.$broadcast('reqDataUpdate');
            }
          }, 100);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for Temperature Monitoring Widget..');
          $scope.isWidgetPreInitFinished = true;
          $scope.isWidgetPostInitFinished = true;
          $scope.isDataNotAvailable = true;
          currentParentRowResEvent();
        }
      }
    });

    function _handleDataUpdate(dashboardName, tabNumber, rowData, widgetName , currentActiveTab) { // if tab clicked same method is called with currect active tab numer
      var set;

      switch (dashboardName) {
        case 'dashboard.vehicleList':
        case 'dashboard.driverWrkHrsDashboard': // contains only tab 0
        case 'dashboard.tachohistory': // contains only tab 0
          switch (tabNumber) {
            case 1:
              if (!_.isEmpty(rowData)) {
                _intRequestData({ name: 'ordersRowSelected' }, {
                  selectedRow: rowData, 'startDate': commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false),
                  'endDate': commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false),
                }, currentActiveTab);
              } else {
                $scope.isDataNotAvailable = true;
              }
              break;
            case 0: // all tabs uses first tab master data to load the Temperature Values
            case 2:
            case 3:
              set = getSetData(widgetName);
              if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
                rowData = set['tab_' + 0 + '_selectedRow'].value;
                _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
              }
              break;
          }
          break;
        case 'dashboard.fmsDashboard':
          switch (tabNumber) {
            case 0:
            case 1:
              _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
              break;
            case 2:
              set = getSetData(widgetName);
              if (!_.isEmpty(set['tab_' + 0 + '_selectedRow'])) {
                rowData = set['tab_' + 0 + '_selectedRow'].value;
                _intRequestData({}, { selectedRow: rowData }, currentActiveTab);
              }
              break;
          }
          break;
      }
    }


    $timeout(function () {
      $scope.initSummaryTab();
    }, 0);


    // consistancy Auto Refresh

    var consitancyCounteInterval = null;
    var consistancyRefreshIntervalValue = 10; // 10s
    // counter to display in UI
    $scope.consistancyConter = consistancyRefreshIntervalValue; // initialize the counter

    // staart constancy auto refresh
    $scope.startConsistancyAutoRefresh = function () {

      $scope.stopConsistancyAutoRefresh();

      if ($scope.consistancyConter - 1 >= 1) {
        $scope.consistancyConter--;
        consitancyCounteInterval = $interval($scope.startConsistancyAutoRefresh, 1000);
      } else {
        // reached 10s stop any auto refresh and call the data from server
        $scope.stopConsistancyAutoRefresh();
        _reloadConsitancyChartForAutoRefresh();
        // start the next 10s refresh cycle
        $scope.consistancyConter = consistancyRefreshIntervalValue;
        consitancyCounteInterval = $interval($scope.startConsistancyAutoRefresh, 1000);

      }
    };

    // call constancy reports for last fifteen minutes and start the refresh cycle again
    function _reloadConsitancyChartForAutoRefresh(){
      var currentTime = new Date();
      var accountTimeZone = $scope.accountSettings && $scope.accountSettings.timeZone ? $scope.accountSettings.timeZone : 'Europe/Berlin';
      var accountTimeString = (currentTime).toLocaleString('en-US', {timeZone: accountTimeZone});
      var accountDate = new Date(accountTimeString);

      var currentMoment = moment(accountDate);
      $scope.temperatureDetail.date.endDate = currentMoment.clone().format('YYYY/MM/DD/HH:mm:ss');
      $scope.temperatureDetail.date.startDate = currentMoment.clone().subtract(15, 'minutes').format('YYYY/MM/DD/HH:mm:ss');

      if (config.deviceId ||  $scope.parentWidgetData.deviceID) {
        $scope.reloadChartData = true;
        $scope.reloadConsistencyChartData = true;
        var loadConsistencyData = $scope.activeTab === consistencyTab;
        loadThermoOrConsistencyData(config.deviceId ||  $scope.parentWidgetData.deviceID, $scope.temperatureDetail.date.startDate, $scope.temperatureDetail.date.endDate, loadConsistencyData);
      }
    }

    // stop auto refresh cancel any refrency of exiting intervals
    $scope.stopConsistancyAutoRefresh = function () {
      $interval.cancel(consitancyCounteInterval);
    };

    // when user modifies the checkbox , method will be executed
    $scope.consistanceAutoUpdateCheckBoxChange = function (isAutoRefreshChecked) {

      // if checked start the auto refresh , else stop any existing
      if (isAutoRefreshChecked) {
        _reloadConsitancyChartForAutoRefresh();// for intial loading
        $scope.consistancyConter = consistancyRefreshIntervalValue;
        $scope.startConsistancyAutoRefresh();
      } else {
        $scope.consistancyConter = consistancyRefreshIntervalValue;
        $scope.stopConsistancyAutoRefresh();
      }
    };


    // watch the accodion open /close state
    $scope.$watch('consitancytab.isAmbientTempChartOpen', function () {
      if (!$scope.thermoDataLoading) {
        accordionStateChanged();
      }
    });
     // watch the accodion open /close state
    $scope.$watch('consitancytab.isConsistancyChartOpen', function () {
      if (!$scope.thermoDataLoading) {
        accordionStateChanged();
      }
    });
     // watch the accodion open /close state
    $scope.$watch('consitancytab.isDrumRpmChartOpen', function () {
      if (!$scope.thermoDataLoading) {
        accordionStateChanged();
      }
    });
     // watch the accodion open /close state
    $scope.$watch('consitancytab.isConsistencyChartWaterOpen', function () {
      if (!$scope.thermoDataLoading) {
        accordionStateChanged();
      }
    });
     // watch the accodion open /close state
    $scope.$watch('consitancytab.isConsistencyChartTemperatureOpen', function () {
      if (!$scope.thermoDataLoading) {
        accordionStateChanged();
      }
    });



    /**
     * determines the no of open and closed accordions ,
     *
     * calculates heights for each chart based on no of open accordions.
     *
     */
    function accordionStateChanged() {

        var noOdAccordionOpen = 0;
        var defaultHeight = 300;
        var totalHeightOfallAccordion = 1200;
        var heightForEachOpenedAccordion;
        var openedAccordionHeightExpression = [];
        var existingAccordionHeightExpress =['ambientTempChartHeight' ,'consistancyChartHeight', 'drumRpmChartHeight', 'consistencyChartWaterHeight', 'consistencyChartTemperatureHeight'];


        // find the nof open accordions
        if ($scope.consitancytab.isAmbientTempChartOpen) {
          noOdAccordionOpen++;
          openedAccordionHeightExpression.push('ambientTempChartHeight');
        }
        if ($scope.consitancytab.isConsistancyChartOpen) {
          noOdAccordionOpen++;
          openedAccordionHeightExpression.push('consistancyChartHeight');
        }
        if ($scope.consitancytab.isDrumRpmChartOpen) {
          noOdAccordionOpen++;
          openedAccordionHeightExpression.push('drumRpmChartHeight');
        }
        if ($scope.consitancytab.isConsistencyChartWaterOpen) {
          noOdAccordionOpen++;
          openedAccordionHeightExpression.push('consistencyChartWaterHeight');
        }
        if ($scope.consitancytab.isConsistencyChartTemperatureOpen) {
          noOdAccordionOpen++;
          openedAccordionHeightExpression.push('consistencyChartTemperatureHeight');
        }


        // calculate height for each opned accordion charts
        if (noOdAccordionOpen > 0) {
          heightForEachOpenedAccordion = totalHeightOfallAccordion / noOdAccordionOpen;
          // default to max allowed value to  600 px
          heightForEachOpenedAccordion  =  heightForEachOpenedAccordion > 600 ? 600 :heightForEachOpenedAccordion;
        }

        if (openedAccordionHeightExpression.length > 0) {

          var closedAccordions = existingAccordionHeightExpress.filter(function (e) {
            return !openedAccordionHeightExpression.includes(e);
          });

          // set default height for the closed accordions
          for (var closedTmp = 0; closedTmp < closedAccordions.length; closedTmp++) {
            $scope.consitancytab[closedAccordions[closedTmp]] = defaultHeight + 'px';
          }

          // adopt the height of opened accordions
          for (var tmpi = 0; tmpi < openedAccordionHeightExpression.length; tmpi++) {
            switch (openedAccordionHeightExpression[tmpi]) {
              case 'ambientTempChartHeight':
                $scope.consitancytab.ambientTempChartHeight = heightForEachOpenedAccordion+'px';
                _refreshChartDomAfterSettingHeight('jqxConsistencyChart3');
                break;
              case 'consistancyChartHeight':
                $scope.consitancytab.consistancyChartHeight = heightForEachOpenedAccordion+'px';
                _refreshChartDomAfterSettingHeight('jqxConsistencyChart1');
                break;
              case 'drumRpmChartHeight':
                $scope.consitancytab.drumRpmChartHeight= heightForEachOpenedAccordion+'px';
                _refreshChartDomAfterSettingHeight('jqxConsistencyChart2');
                break;
              case 'consistencyChartWaterHeight':
                $scope.consitancytab.consistencyChartWaterHeight= heightForEachOpenedAccordion+'px';
                _refreshChartDomAfterSettingHeight('jqxConsistencyChartWater');
                break;
              case 'consistencyChartTemperatureHeight':
                $scope.consitancytab.consistencyChartTemperatureHeight= heightForEachOpenedAccordion+'px';
                _refreshChartDomAfterSettingHeight('jqxConsistencyChartTemperature');
                break;
            }

          }
        }
       // console.log($scope.consitancytab);
    }
    // when dynamic height is set refresh call on chart is must to adopt the chart height
    function _refreshChartDomAfterSettingHeight(chartDomId){
      setTimeout(function(){
        $('#'+chartDomId).jqxChart('refresh');
      }, 0);

    }
    $scope.$on('$destroy', function () {
      if ($state.current.name !== 'dashboard' && $state.current.name !== 'betotrack.dashboard') {
        TempMonitoringService.setRowEventStatus(false);
      }
      if ($scope.doorStatusChartSettings && $scope.doorStatusChartSettings.source) {
        delete $scope.doorStatusChartSettings.source;
      }
      if ($scope.tempratursChartHistory && $scope.tempratursChartHistory.source) {
        delete $scope.tempratursChartHistory.source;
      }
      if ($scope.rangeSelectorSettings) {
        delete $scope.rangeSelectorSettings;
      }
	  [$scope.consistencyChart1Settings, $scope.consistencyChartWaterSettings, $scope.consistencyChartTemperatureSettings, $scope.consistencyChart2Settings, $scope.consistencyChart3Settings].forEach(function(settings){
        if (settings && settings.source) {
          delete settings.source;
        }
      });
      currentParentRowResEvent();
      dataStateUpdateListener();
      // remove any listener if any
      $interval.cancel(consitancyCounteInterval);
    });
  }).controller('TempMonitoringEditCtrl', function ($scope, config) {
    $scope.tempMonitor = {};
    $scope.tempMonitor = {
      maxHours: config.maxHours,
      temperatureUnit: config.temperatureUnit,
      max: config.max,
      min: config.min
    };

    $scope.maxIsOdd = false;
    $scope.minIsOdd = false;

    $scope.$watch('tempMonitor.maxHours', function (maxHours) {
      if (maxHours) {
        config.maxHours = maxHours;
      }
    });
    $scope.$watch('tempMonitor.max', function (max) {
      if (max % 2 !== 0) {
        $scope.maxIsOdd = true;
      } else {
        $scope.maxIsOdd = false;
        config.max = max;
      }

    });


    $scope.$watch('tempMonitor.min', function (min) {
      if (min % 2 !== 0) {
        $scope.minIsOdd = true;
      } else {
        $scope.minIsOdd = false;
        config.min = min;
      }
    });

  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/deviceSummary/deviceSummaryWidget.js